import React from "react";

const TrackingPolicyAllocation = () => {
    return <div>TrackingPolicyAllocation</div>;
}

export default TrackingPolicyAllocation;